import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import AddUserIcon from '@mui/icons-material/Add';
import AddUserImage from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Dropzone from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  ValidatorForm,
  TextValidator,
} from 'react-material-ui-form-validator';
import { toast } from 'react-toastify';
import spinner from '../assign-prescriptions/images/spinner.gif';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import {
  AppBar,
  Tabs,
  Tab,
  FormControl,
  Divider,
  Stack
} from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import USER_ROLES from '../common/userroles';
import moment from 'moment-timezone';
import { IMaskInput } from 'react-imask';
import { Box } from '@mui/system';
import { withTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import { Input, InputAdornment, FormHelperText, OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    // identityPoolId: 'us-east-1:16c7cd5e-52d1-442d-af74-235153fea56d',
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_CG_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID,
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: true,
    // // OPTIONAL - Configuration for cookie storage
    //     cookieStorage: {
    //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //         domain: '.yourdomain.com',
    //     // OPTIONAL - Cookie path
    //         path: '/',
    //     // OPTIONAL - Cookie expiration in days
    //         expires: 365,
    //     // OPTIONAL - Cookie secure flag
    //         secure: true
    //     }
  },
});

const localeTheme = createTheme(
  {},
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR
);

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component='div' dir={dir}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      sortId,
      t,

    } = this.props;
    const rows = [
      {
        id: 'avatar',
        numeric: false,
        disablePadding: true,
        label: t('Vendors.Picture'),
        field: 'logo_url',
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.Name'),
        field: 'name',
      },
      {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.Email'),
        field: 'email',
      },
      {
        id: 'phone',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.Phone'),
        field: 'phone',
      },
      {
        id: 'cp_name',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.ContactPersonName'),
        field: 'cp_name',
      },
      {
        id: 'cp_email',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.ContactPersonEmail'),
        field: 'cp_email',
      },
      {
        id: 'cp_phone',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.ContactPersonPhone'),
        field: 'cp_phone',
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: t('Vendors.Actions'),
      },
    ];
    return (
      <TableHead sx={{ height: '56px' }}>
        <TableRow>
          <TableCell sx={{ padding: '0 12px' }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                '&.Mui-checked': { color: '#0ae' },
                '&.MuiCheckbox-indeterminate': { color: '#0ae' },
              }}
            />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={'none'}
                sortDirection={orderBy === row.id ? order : false}
                sx={{
                  color: 'rgba(0, 0, 0, 0.54)',
                  fontSize: '0.75rem',
                  fontWeight: '500',
                }}
              >
                {['avatar', 'actions'].includes(
                  row.id
                ) ? (
                  <TableSortLabel sx={{ '.MuiSvgIcon-root': { fontSize: 16 } }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t('Global.Label.Filter.Sort')}
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                      sx={{ '.MuiSvgIcon-root': { fontSize: 16 } }}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#00a7e1',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    uadd,
    udelete,
    handleSearchChange,
    searchtxt,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color='' variant='subheading'>
            {numSelected} {t('Vendors.SelectedRowsCount')}
          </Typography>
        ) : (
          <div>
            <TextField
              label={t('Vendors.Search')}
              onChange={handleSearchChange}
              value={searchtxt}
              fullWidth
              inputProps={{
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              sx={{ width: '30ch' }}
              variant='standard'
            />
          </div>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 ? (
          <div>
            {udelete === true ? (
              <Tooltip
                key='single-delete'
                title={t('Vendors.DeleteVendorsTooltip')}
              >
                <IconButton
                  aria-label='Delete'
                  onClick={confirmDelete}
                  sx={() => ({
                    '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ''
            )}
          </div>
        ) : numSelected > 1 ? (
          udelete === true ? (
            <Tooltip key='multi-delete' title={t('Vendors.DeleteVendorsTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                sx={() => ({
                  '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          )
        ) : uadd === true ? (
          <Tooltip key='single-add' title={t('Vendors.AddVendorsTooltip')}>
            <IconButton
              aria-label='Add Vendor'
              className={classes.add}
              onClick={add}
            >
              <AddUserIcon />
            </IconButton>
          </Tooltip>
        ) : (
          ''
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: '985px',
  },
  root: {
    width: '100%',
  },
  table: {
    minWidth: 'auto',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  halfTextField: {
    marginRight: '20px',
  },
  dropbox: {
    width: '135px',
    height: '105px',
    float: 'right',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '56px',
    right: '2px',
    position: 'relative',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  errorDiv: {
    paddingTop: '10px',
    color: 'red',
  },
  captionText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    textAlign: 'center',
  },
  twoChildren: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftChild: {},
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  formControl: {
    margin: '5px',
    minWidth: '100%',
  },
  boxDesign: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  dialogTitle: {
    fontSize: '1.3125rem',
    fontWeight: 500,
    lineHeight: '1.16667em',
  },
  menuItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
});

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='(#00) 000-0000'
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const ITEM_HEIGHT = 48;
let imgFile;

let FilterObj = {
  searchtext: '',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      selected: [],
      page: 0,
      rowsPerPage: 10,
      submitted: false,
      isButtonDisabled: false,
      userview: true,
      useradd: true,
      userdelete: true,
      useredit: true,
      keysgen: true,
      keysview: true,
      showPassword: false,
      accessPassword: '',
      accessPassError: null,
      // selectedRowId: null,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        vendor_name: '',
        vendor_email: '',
        vendor_phone: '',
        vendor_addressLine1: '',
        vendor_addressLine2: '',
      },
      searchtext: '',
      loader: false,
      disabledText: 'Disable',
      chipstores: [],
      chipboxes: [],
      isDisabled: false,
      selectedTab: 0,
      innerLoader: false,
      isSuperAdmin: false,
      isAdmin: false,
      totalRecords: 0,
      preferredLanguage: [
        { id: 'en', label: this.props.t('Global.Language.English') },
        { id: 'fr', label: this.props.t('Global.Language.French') },
      ],
      preferLanguage: 'en',
      loadState: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      isSuperAdmin:
        sessionStorage.hasOwnProperty('superadmin') &&
        JSON.parse(sessionStorage.getItem('superadmin')) ===
        USER_ROLES.SUPERADMIN,
      isAdmin:
        sessionStorage.hasOwnProperty('admin') &&
        JSON.parse(sessionStorage.getItem('admin')) === USER_ROLES.ADMIN,
    });

    this.BindBoxes();

    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({
          accountValues,
          parent_account_id: accountValues[0].value,
        });
      });
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));
    if (permissions && permissions.length > 0) {
      let permissionObj = {};
      permissions.map((item) => {
        return item.permission_entity_type === 'Manage Users' &&
          item.name === 'View'
          ? (permissionObj.view = true)
          : item.permission_entity_type === 'Manage Users' &&
            item.name === 'Add '
            ? (permissionObj.add = true)
            : item.permission_entity_type === 'Manage Users' &&
              item.name === 'Modify '
              ? (permissionObj.modify = true)
              : item.permission_entity_type === 'Manage Users' &&
                item.name === 'Delete '
                ? (permissionObj.delete = true)
                : null;
      });
      if (permissionObj.view) {
        this.setState({ userview: true });
      } else {
        this.setState({ userview: false });
      }
      if (permissionObj.add) {
        this.setState({ useradd: true });
      } else {
        this.setState({ useradd: false });
      }
      if (permissionObj.modify) {
        this.setState({ useredit: true });
      } else {
        this.setState({ useredit: false });
      }
      if (permissionObj.delete) {
        this.setState({ userdelete: true });
      } else {
        this.setState({ userdelete: false });
      }
      if (permissions[22].is_allowed === false) {
        this.setState({ userview: false });
      }
      if (permissions[23].is_allowed === false) {
        this.setState({ useradd: false });
      }
      if (permissions[25].is_allowed === false) {
        this.setState({ userdelete: false });
      }
      if (permissions[24].is_allowed === false) {
        this.setState({ useredit: false });
      }
    } else {
      this.setState({ userview: false });
      this.setState({ useradd: false });
      this.setState({ useredit: false });
      this.setState({ userdelete: false });
    }

    // custom validation rule for phone number validation
    ValidatorForm.addValidationRule('isTenDigits', (value) => {
      if (value) {
        const strippedValue = value.replace(/\D/g, ''); // Remove non-digit characters
        return strippedValue.length === 10;
      }
    });
  }

  componentWillUnmount() {
    // Remove the custom validation rule to avoid memory leaks
    console.log("Rule removed")
    ValidatorForm.removeValidationRule('isTenDigits');
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  BindBoxes() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + `api/v1/subscriptions/vendorManagement/getAllVendors?searchtext=${FilterObj.searchtext}&pageNo=${FilterObj.pageNo}&pageSize=${FilterObj.pageSize}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}&tableName=${FilterObj.tableName}`, {
      method: 'get',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        this.setState({ totalRecords: data && data.total });
        if (data && data.allVendorsDetails && data.allVendorsDetails.length > 0) {
          this.setState(
            { data: data.allVendorsDetails, loader: false, isDataEmpty: false }
          );
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  }

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (
      [
        'name',
        'username',
      ].includes(field)
    ) {
      tablename = 'vendor_management';
    }
    if (['email', 'phone'].includes(field)) {
      tablename = 'contacts';
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.vendor_unique_id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    FilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindBoxes();
    }
  };

  addUser = (event) => {
    this.setState({
      isPhoneError: false,
      isCPPhoneError: false,
      showNewUserDialog: true,
      user: {},
      operation: 'Add',
      first_name: '',
      last_name: '',
      email: '',
      avatarPreview: null,
      phone: null,
      disabledText: 'Disable',
      selectedTab: 0,
    });
  };

  deleteUsers = (event) => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      'api/v1/subscriptions/vendorManagement/deleteVendorByID/' +
      this.state.selected.join(',').trim(','),
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.vendor_unique_id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
      this.handleClose();
      this.BindBoxes();
    });
  };

  handleClose = (event) => {
    this.setState({ showNewUserDialog: false, user: {}, city: '', state: '', zip: '', errorMessage: '' });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  isvalidEmail(email) {
    console.log('this.state.email', this.state.email);
    const trulyValue = email === this.state.email;
    if (!trulyValue) {
      return false;
    }
    return trulyValue;
  }

  checkEmail = (event) => {
    this.setState({ loader: true });
    const searchedString = event.target.value;
    this.setState({ email: searchedString });
    if (searchedString.length > 0) {
      let isvalid = this.isvalidEmail(searchedString);
      if (isvalid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL +
          'checkemailexistornot/' +
          searchedString,
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((emailcheck) => {
            this.setState({ loader: false });
            if (emailcheck && emailcheck.email_Is_Exist) {
              toast.error(this.props.t('Toast.Error.Email'));
              this.setState({ email: '' });
            } else {
              this.setState({ emailcheck });
            }
          });
      } else this.setState({ loader: false });
    }
  };

  handleChange = (event) => {
    if (event.preventDefault) event.preventDefault();
    const { target: { id, name, value } } = event;
    if (id === 'vendor_phone') {
      this.setState({ isPhoneError: false, });
    } else if (id === 'phone') {
      this.setState({ isCPPhoneError: false, });
    }
    const { user } = this.state;
    if (['email', 'vendor_email'].includes(name || id)) {
      user[name || id] = (value || '').toLowerCase();
    } else user[name || id] = value;
    this.setState(user);
  };

  removeImg = () => {
    const parent = document.getElementById('avatardropzone');
    if (parent) {
      let imgSrc = ((parent.children && parent.children[0]).src = '');
      imgFile = new File([imgSrc], 'filename');
    } else {
      imgFile = new File([''], 'filename');
    }

  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.vendor_unique_id === this.state.selectedRowId
    );
    this.setState({ selectedTab: 0, isPhoneError: false, isCPPhoneError: false, });
    this.setState({
      showNewUserDialog: true,
      operation: 'View',
      user: {
        vendor_name: selectedObject.name,
        vendor_email: selectedObject.email,
        vendor_phone: selectedObject.phone,
        vendor_addressLine1: selectedObject.address_line_1,
        vendor_addressLine2: selectedObject.address_line_2
      },
      city: selectedObject.city,
      state: selectedObject.state,
      zip: selectedObject.zip,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.cp_name.split(' ')[0],
      last_name: selectedObject.cp_name.split(' ')[1],
      email: selectedObject.cp_email,
      avatarPreview: selectedObject.logo_url && JSON.parse(selectedObject.logo_url).Location,
      phone: selectedObject.cp_phone,
      // -- Need to enable when we deployed appountments.
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      preferLanguage: this.state.preferLanguage,
    });
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.vendor_unique_id === this.state.selectedRowId
    );
    this.setState({ selectedTab: 0, isPhoneError: false, isCPPhoneError: false, });
    this.setState({
      showNewUserDialog: true,
      operation: 'Edit',
      user: {
        vendor_name: selectedObject.name,
        vendor_email: selectedObject.email,
        vendor_phone: selectedObject.phone,
        vendor_addressLine1: selectedObject.address_line_1,
        vendor_addressLine2: selectedObject.address_line_2
      },
      city: selectedObject.city,
      state: selectedObject.state,
      zip: selectedObject.zip,
      vendor_unique_id: selectedObject.vendor_unique_id,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.cp_name.split(' ')[0],
      last_name: selectedObject.cp_name.split(' ')[1],
      email: selectedObject.cp_email,
      avatarPreview: selectedObject.logo_url && JSON.parse(selectedObject.logo_url).Location,
      phone: selectedObject.cp_phone,
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      preferLanguage: this.state.preferLanguage,
    });
    this.handleContextClose(event);
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.vendor_unique_id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.vendor_unique_id) > -1
        ),
      });
    }
  };

  handleGenerate = (event) => {
    fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/secrets/generate', {
      method: 'post',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ vendorid: this.state.selectedRowId })
    })
      .then((result) => {
        result.json().then((res) => {
          if (res.success) {
            this.setState({
              vendorToken: res.vendor_token,
              generateKeyDialogOpen: true
            })
            this.BindBoxes();
          } else {
            toast.error()
          }
        })
      })
      .catch(error => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message, isButtonDisabled: false });
      })
  }

  generateClose = (event) => {
    this.handleContextClose(event);
    this.setState({
      generateKeyDialogOpen: false,
    })
  }

  handleKeysView = (event) => {
    for (let i = 0; i < this.state.data.length; i++) {
      const ele = this.state.data[i];
      if (ele.vendor_unique_id === this.state.selectedRowId) {
        this.setState({
          vendorToken: ele.vendor_token,
          viewKeyDialogOpen: true,
          isRevoked: ele.is_revoked
        })
        break
      }
    }
  }

  viewKeyClose = (event) => {
    this.handleContextClose(event);
    this.setState({
      viewKeyDialogOpen: false,
    })
  }

  revokeKeyClose = (event) => {
    this.setState({
      revokeKeyDialogOpen: false,
      accessPassword: '',
      accessPassError: null,
      showPassword: false
    })
  }

  grantKeyClose = (event) => {
    this.setState({
      grantKeyDialogOpen: false,
      accessPassword: '',
      accessPassError: null,
      showPassword: false
    })
  }

  handleRevokeKey = (event) => {
    this.setState({
      revokeKeyDialogOpen: true,
    })
  }

  handleGrantKey = (event) => {
    this.setState({
      grantKeyDialogOpen: true,
    })
  }

  confirmRevokeKey = (event) => {
    if (this.state.accessPassword === '') {
      this.setState({
        accessPassError: 'Field must not be empty.'
      })
    } else {
      Auth.currentAuthenticatedUser({
        bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then((user) => {
          this.setState({ loader: true })
          Auth.signIn(user.attributes.email, this.state.accessPassword)
            .then(result => {
              fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/secrets/actions/Revoke', {
                method: 'post',
                headers: {
                  Authorization:
                    'Bearer ' +
                    JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                      .jwtToken,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ vendorid: this.state.selectedRowId })
              })
                .then((result) => {
                  result.json().then((res) => {
                    if (res.success) {
                      toast.success(this.props.t('Toast.Success.VendorAccessRevoked'))
                    } else {
                      toast.error()
                    }
                    this.setState({
                      viewKeyDialogOpen: false,
                      revokeKeyDialogOpen: false,
                      accessPassword: '',
                      loader: false,
                      showPassword: false
                    })
                    this.handleContextClose(event);
                    this.BindBoxes();
                  })
                })
                .catch(error => {
                  this.setState({ loader: false });
                  this.setState({ errorMessage: error.message, isButtonDisabled: false });
                })
            })
            .catch(error => {
              this.setState({ loader: false });
              this.setState({
                accessPassError: this.props.t('Toast.Error.PasswordError')
              })
            })
        })
        .catch((error) => {
          toast.error(this.props.t('Toast.Error.AuthenticationFailed'))
        });
    }
  }

  handleClickShowPassword = (event) => {
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  handleClickCopyToClipboard = (val) => {
    navigator.clipboard.writeText(val)
  }

  handleMouseDownCopyToClipboard = (e) => {
    e.preventDefault();
  }

  handleAccessPassChange = (event) => {
    if (event.target.value === '') {
      this.setState({
        accessPassError: true,
        accessPassword: event.target.value
      })
    } else {
      this.setState({
        accessPassError: false,
        accessPassword: event.target.value
      })
    }
  }

  confirmGrantKey = (event) => {
    if (this.state.accessPassword === '') {
      this.setState({
        accessPassError: 'Field must not be empty.'
      })
    } else {
      Auth.currentAuthenticatedUser({
        bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then((user) => {
          this.setState({ loader: true })
          Auth.signIn(user.attributes.email, this.state.accessPassword)
            .then(result => {
              fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/secrets/actions/Grant', {
                method: 'post',
                headers: {
                  Authorization:
                    'Bearer ' +
                    JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                      .jwtToken,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ vendorid: this.state.selectedRowId })
              })
                .then((result) => {
                  result.json().then((res) => {
                    if (res.success) {
                      toast.success(this.props.t('Toast.Success.VendorAccessGranted'))
                    } else {
                      toast.error()
                    }
                    this.setState({
                      viewKeyDialogOpen: false,
                      grantKeyDialogOpen: false,
                      accessPassword: '',
                      loader: false,
                      showPassword: false
                    })
                    this.handleContextClose(event);
                    this.BindBoxes();
                  })
                })
                .catch(error => {
                  this.setState({ loader: false });
                  this.setState({ errorMessage: error.message, isButtonDisabled: false });
                })
            })
            .catch(error => {
              this.setState({ loader: false });
              this.setState({
                accessPassError: this.props.t('Toast.Error.PasswordError')
              })
            })
        })
        .catch((error) => {
          toast.error(this.props.t('Toast.Error.AuthenticationFailed'))
        });
    }
  }

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteUsers();
    }
    this.setState({ deleteDialogOpen: false });
    toast.success(this.props.t('Toast.Success.VendorRemoved'));
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/vendorManagement/deleteVendorByID/' + rowIdToDelete,
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
        selectedRowId: null,
      });
      this.handleContextClose(event);
      this.BindBoxes();
    });
  };

  handleSearchChange = (event) => {
    let searchtxt = '';
    searchtxt = event.target.value;
    this.setState({ searchtext: event.target.value });
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    if (searchtxt.length >= 3) {
      FilterObj.searchtext = searchtxt;
      this.BindBoxes();
    } else if (searchtxt.length === 0) {
      FilterObj.searchtext = '';
      this.BindBoxes();
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      loader: true,
      isButtonDisabled: true,
      isPhoneError: false,
      isCPPhoneError: false,
    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    data.append('file', input.files[0]);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('vendor_name', this.state.vendor_name);
    data.append('vendor_email', this.state.vendor_email);
    data.append('vendor_phone', this.state.vendor_phone);
    data.append('vendor_addressLine1', this.state.vendor_addressLine1);
    data.append('vendor_addressLine2', this.state.vendor_addressLine2);
    data.append('city', this.state.city);
    data.append('state', this.state.state);
    data.append('zip', this.state.zip);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);

    const result = fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/vendorManagement/createVendor', {
      method: 'POST',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,
              isPhoneError: false,
              isCPPhoneError: false,
            });
            if (res.success === false) {
              toast.error(res.message);
            }
          } else {
            this.state.data.unshift(res.user);
            const newData = JSON.parse(JSON.stringify(this.state.data));
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: newData,
              searchtext: '',
            });
            toast.success(this.props.t('Toast.Success.VendorAdded'));
            FilterObj.searchtext = '';
            FilterObj.sortOrder = 'desc';
            FilterObj.sortColumn = 'created_on';
            FilterObj.tableName = '';
            this.handleClose();
            this.BindBoxes();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message, isButtonDisabled: false });
      });
  };

  changeLanguage = () => {
    let loggedinUserID = JSON.parse(sessionStorage.getItem('user')).username;
    if (this.state.user.id !== loggedinUserID) {
      return true;
    }

    let preferLanguage = sessionStorage.getItem('preferredLanguage');
    if (this.state.preferLanguage !== preferLanguage) {
      sessionStorage.setItem('preferredLanguage', this.state.preferLanguage);
      const { i18n } = this.props;
      i18n.changeLanguage(this.state.preferLanguage);
    }
  };

  handleUpdate = (event) => {
    event.preventDefault();
    this.setState({
      loader: true,
      isButtonDisabled: true,
      isPhoneError: false,
      isCPPhoneError: false,
    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    if (
      input.files !== null &&
      input.files !== undefined &&
      input.files.length > 0
    ) {
      if (input.files[0] != null || '') {
        data.append('file', input.files[0] || this.state.avatarPreview);
      } else {
        data.append('file', imgFile[0]);
      }
    }
    data.append('vendorID', this.state.vendor_unique_id);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('vendor_name', this.state.vendor_name);
    data.append('vendor_email', this.state.vendor_email);
    data.append('vendor_phone', this.state.vendor_phone);
    data.append('vendor_addressLine1', this.state.vendor_addressLine1);
    data.append('vendor_addressLine2', this.state.vendor_addressLine2);
    data.append('city', this.state.city);
    data.append('state', this.state.state);
    data.append('zip', this.state.zip);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);

    const result = fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/vendorManagement/updateVendor', {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,
              isPhoneError: false,
              isCPPhoneError: false,
            });
            this.setState({ errorMessage: res.error.message });
          } else {
            const newData = this.state.data.filter(
              (x) => x.id !== this.state.user.id
            );
            newData.unshift(res.user);
            this.changeLanguage();
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: JSON.parse(JSON.stringify(newData)),
              searchtext: '',
            });
            toast.success(this.props.t('Toast.Success.VendorUpdated'));
            FilterObj.searchtext = '';
            FilterObj.sortOrder = 'desc';
            FilterObj.sortColumn = 'created_on';
            FilterObj.tableName = '';
            this.handleClose();
            this.BindBoxes();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message });
      });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClick = (event, n) => {
    event.preventDefault();
    let isKeyGenerated = false
    if (n.vendor_token !== null) {
      isKeyGenerated = true
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.vendor_unique_id,
      isKeyGenerated: isKeyGenerated
    });
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null, isKeyGenerated: null });
  }

  handleStoreChange = (event) => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex((x) => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        processed.push(this.state.roleLookupValues[i]);
      }
    } else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        const element = storeid.findIndex(
          (x) => x.id === this.state.roleLookupValues[i].id
        );
        if (element > -1) {
        } else {
          chipprocessed.push(this.state.roleLookupValues[i]);
          processed.push(this.state.roleLookupValues[i]);
        }
      }
    } else if (storeid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    } else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        } else {
        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ roles: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id);
        }
      }
    }
  };
  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }

  onChangePreferredLanguage = (event) => {
    event.preventDefault && event.preventDefault();
    const { value } = event.target;
    this.setState({ preferLanguage: value });
  };

  render() {
    const { classes, theme, t, } = this.props;

    const {
      data,
      selected,
      anchorEl,
      user,
      totalRecords,
      preferLanguage,
    } = this.state;
    const contextOpen = Boolean(anchorEl);
    const readOnly = this.state.operation === 'View';

    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Vendors.AreYouSureDeleteText')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Vendors.AreYouSureDeleteBodyText')} :
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.AreYouSureDeleteCancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Vendors.AreYouSureDeleteButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.generateKeyDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Vendors.GenerateKeysTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Stack spacing={2}>
                <item>{t('Vendors.VendorID')} : {this.state.selectedRowId}</item>
                <item>{t('Vendors.VendorToken')} :
                  <OutlinedInput
                    sx={{ height: "25px", width: "30ch", padding: "0", marginLeft: "4px", }}
                    id="outlined-adornment-copyToClipboard"
                    value={this.state.vendorToken}
                    readOnly
                    type="text"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="copy to clipboard"
                          onClick={() => this.handleClickCopyToClipboard(this.state.vendorToken)}
                          onMouseDown={this.handleMouseDownCopyToClipboard}
                          edge="end"
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </item>
              </Stack>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.generateClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.CloseButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.viewKeyDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Vendors.GenerateKeysTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Stack spacing={2}>
                <item>{t('Vendors.VendorID')} : {this.state.selectedRowId}</item>
                <item>{t('Vendors.VendorToken')} :
                  <OutlinedInput
                    sx={{ height: "25px", width: "30ch", padding: "0", marginLeft: "4px", }}
                    id="outlined-adornment-copyToClipboard"
                    value={this.state.vendorToken}
                    readOnly
                    type="text"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="copy to clipboard"
                          onClick={() => this.handleClickCopyToClipboard(this.state.vendorToken)}
                          onMouseDown={this.handleMouseDownCopyToClipboard}
                          edge="end"
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </item>
              </Stack>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {this.state.isRevoked ?
              <Button
                onClick={() => { this.handleGrantKey() }}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Vendors.GrantButton')}
              </Button>
              :
              <Button
                onClick={this.handleRevokeKey}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Vendors.RevokeButton')}
              </Button>
            }
            <Button
              onClick={this.viewKeyClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.CloseButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.revokeKeyDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <DialogTitle id='alert-dialog-title'>
            {t('Vendors.RevokeKeysTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                <InputLabel htmlFor="standard-adornment-password">{t('Vendors.VendorDetails.Password')}</InputLabel>
                <Input
                  error={this.state.accessPassError}
                  defaultValue={this.state.accessPassword}
                  onChange={this.handleAccessPassChange}
                  id="standard-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(e) => { this.handleClickShowPassword(e) }}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText id="component-helper-text" sx={{ color: 'red' }}>
                  {this.state.accessPassError ? this.state.accessPassError : ''}
                </FormHelperText>
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => { this.confirmRevokeKey(e) }}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.YesButton')}
            </Button>
            <Button
              onClick={(e) => { this.revokeKeyClose(e) }}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.NoButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.grantKeyDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <DialogTitle id='alert-dialog-title'>
            {t('Vendors.GrantKeysTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                <InputLabel htmlFor="standard-adornment-password">{t('Vendors.VendorDetails.Password')}</InputLabel>
                <Input
                  error={this.state.accessPassError}
                  defaultValue={this.state.accessPassword}
                  onChange={this.handleAccessPassChange}
                  id="standard-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={(e) => { this.handleClickShowPassword(e) }}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText id="component-helper-text" sx={{ color: 'red' }}>
                  {this.state.accessPassError ? this.state.accessPassError : ''}
                </FormHelperText>
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => { this.confirmGrantKey(e) }}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.YesButton')}
            </Button>
            <Button
              onClick={(e) => { this.grantKeyClose(e) }}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Vendors.NoButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth='md'
          open={this.state.showNewUserDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
          classes={{ paper: classes.Paper }}
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <AppBar
            position='static'
            color='default'
            sx={{ backgroundColor: '#f5f5f5 !important' }}
          >
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant={null}
            >
              <Tab
                label={t('Vendors.VendorDetails.VendorDetailsTitle')}
                style={{ minWidth: '160px' }}
              />
            </Tabs>
          </AppBar>
          <SwipeableViews
            style={{ maxWidth: '1025px' }}
            axis={theme && theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.selectedTab}
            onChangeIndex={() => this.handleChangeIndex}
          >
            <TabContainer dir={theme && theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <ValidatorForm
                  ref='form'
                  onSubmit={
                    this.state.operation === 'Add'
                      ? this.handleSubmit
                      : this.handleUpdate
                  }
                  onError={(error) => {
                    if (['', null].includes(this.state.user.vendor_phone)) {
                      this.setState({ isPhoneError: true });
                    }
                    if (['', null].includes(this.state.phone)) {
                      this.setState({ isCPPhoneError: true, });
                    }
                  }}
                >
                  <DialogTitle id='form-dialog-title'>
                    {t(this.state.operation)} {t('Vendors.VendorDetails.Vendor')}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {this.state.operation === 'Add'
                        ? t('Vendors.VendorDetails.VendorsDetailsText')
                        : ''}

                      <span className={classes.errorDiv}>
                        {this.state.errorMessage}
                      </span>
                    </DialogContentText>
                    <Typography
                      variant='title'
                      gutterBottom
                      style={{
                        marginBottom: '0.35em',
                        color: 'rgba(0, 0, 0, 0.87)',
                        fontSize: '1.3125rem',
                        fontWeight: 500,
                        lineHeight: '1.16667em',
                      }}
                    >
                      {t('Vendors.VendorDetails.VendorDetails')}
                    </Typography>
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={user.vendor_name}
                            id='vendor_name'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Vendors.VendorDetails.VendorName')}
                            name='vendor_name'
                            type='vendor-name'
                            placeholder=''
                            style={{ margin: '0px 20px 0px 0px', width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Vendor.Validation.EnterVendorName'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='vendor_email'
                            disabled={['view', 'edit'].includes(
                              this.state.operation
                            )}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              autocomplete: 'off',
                            }}
                            value={user.vendor_email}
                            label={t('Vendors.VendorDetails.EmailAddress')}
                            type='email'
                            name='vendor_email'
                            style={{ margin: '16px 20px 0px 0px', width: '350px' }}
                            onChange={this.handleChange}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                              t('Validation.EnterEmailAddress'),
                              t('Validation.EmailIsNotValid'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            sx={{ m: '16px 20px 0px 0px', width: '350px' }}
                            label={t('Vendors.VendorDetails.PhoneNumber')}
                            value={user.vendor_phone}
                            onChange={this.handleChange}
                            name='vendor_phone'
                            id='vendor_phone'
                            InputProps={{
                              inputComponent: TextMaskCustom,
                              inputProps: {
                                autocomplete: 'off',
                                readOnly: Boolean(readOnly),
                              },
                            }}
                            variant='standard'
                            validators={['required', 'isTenDigits']}
                            errorMessages={[t("Validation.EnterPhoneNumber"), t("Validation.TenDigitPhoneNumber")]}
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            validators={['required']}
                            errorMessages={[t('Validation.EnterAddressLine')]}
                            margin='dense'
                            className={classes.halfTextField}
                            value={user.vendor_addressLine1}
                            id='vendor_addressLine1'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 100,
                            }}
                            label={t('Accounts.AccountDetail.AddressLine1')}
                            placeholder=''
                            onChange={this.handleChange}
                            variant='standard'
                            style={{ margin: '16px 20px 0px 0px', width: '350px' }}
                          />
                          <TextValidator
                            validators={['required']}
                            errorMessages={[t('Validation.EnterAddressLine')]}
                            className={classes.halfTextField}
                            margin='normal'
                            value={user.vendor_addressLine2}
                            id='vendor_addressLine2'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 100,
                            }}
                            label={t('Accounts.AccountDetail.AddressLine2')}
                            placeholder=''
                            onChange={this.handleChange}
                            variant='standard'
                            style={{ margin: '16px 20px 0px 0px', width: '350px' }}
                          />
                        </div>
                        <br />
                        <div style={{ display: 'flex', marginTop: '-1rem' }}>
                          <TextValidator
                            validators={['required', 'matchRegexp:^[a-zA-Z ]*$']}
                            errorMessages={[t('Validation.City'), t('Validation.UseAlphabets')]}
                            className={classes.oneThirdTextField}
                            margin='normal'
                            value={this.state.city}
                            id='city'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            label={t('Accounts.AccountDetail.City')}
                            placeholder=''
                            onChange={this.handleChange}
                            variant='standard'
                            style={{ margin: '0px 20px 0px 0px', width: '226px' }}
                          />
                          <TextValidator
                            validators={['required', 'matchRegexp:^[a-zA-Z ]*$']}
                            errorMessages={[t('Validation.State'), t('Validation.UseAlphabets')]}
                            className={classes.oneThirdTextField}
                            margin='normal'
                            value={this.state.state}
                            id='state'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            label={t('Accounts.AccountDetail.State')}
                            placeholder=''
                            onChange={this.handleChange}
                            variant='standard'
                            style={{ margin: '0px 20px 0px 0px', width: '226px' }}
                          />
                          <TextValidator
                            className={classes.oneThirdTextField}
                            margin='normal'
                            value={this.state.zip}
                            id='zip'
                            name='zip'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 6
                            }}
                            label={t('Accounts.AccountDetail.Zip')}
                            placeholder=''
                            onChange={this.handleChange}
                            validators={['required']}
                            variant='standard'
                            errorMessages={[t('Validation.zip')]}
                            style={{ margin: '0px', width: '227px' }}
                          />
                        </div>
                        <br />
                      </div>
                      <div className={classes.rightChild}>
                        <div className={classes.dropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='avatardropzone'
                              onDrop={this.handleDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <br />
                        <div variant='caption' style={{ paddingTop: '40px' }}>
                          <p className={classes.captionText}>
                            {t('Vendors.VendorDetails.UploadImage')}
                          </p>
                          <Button onClick={this.removeImg}>
                            {t('Vendors.VendorDetails.RemoveImage')}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <Typography
                      variant='title'
                      gutterBottom
                      style={{
                        marginBottom: '0.35em',
                        color: 'rgba(0, 0, 0, 0.87)',
                        fontSize: '1.3125rem',
                        fontWeight: 500,
                        lineHeight: '1.16667em',
                      }}
                    >
                      {t('Vendors.VendorDetails.ContactPerson')}
                    </Typography>
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            value={user.first_name || this.state.first_name}
                            id='first_name'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Vendors.VendorDetails.FirstName')}
                            name='first_name'
                            type='first-name'
                            placeholder=''
                            style={{ margin: '0px 20px 0px 0px', width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Validation.EnterFirstName'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='last_name'
                            value={user.last_name || this.state.last_name}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Vendors.VendorDetails.LastName')}
                            name='last_name'
                            type='last-name'
                            style={{ margin: '0px 20px 0px 0px', width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Validation.EnterLastName'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='email'
                            disabled={['view', 'edit'].includes(
                              this.state.operation
                            )}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              autocomplete: 'off',
                            }}
                            value={String(
                              user.email || this.state.email
                            ).toLowerCase()}
                            label={t('Vendors.VendorDetails.EmailAddress')}
                            type='email'
                            name='email'
                            style={{ margin: '16px 20px 0px 0px', width: '350px' }}
                            onChange={this.handleChange}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                              t('Validation.EnterEmailAddress'),
                              t('Validation.EmailIsNotValid'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            sx={{ m: '16px 20px 0px 0px', width: '350px' }}
                            label={t('Vendors.VendorDetails.PhoneNumber')}
                            value={user.phone || this.state.phone}
                            onChange={this.handleChange}
                            name='phone'
                            id='phone'
                            InputProps={{
                              inputComponent: TextMaskCustom,
                              inputProps: {
                                autocomplete: 'off',
                                readOnly: Boolean(readOnly),
                              },
                            }}
                            variant='standard'
                            validators={['required', 'isTenDigits']}
                            errorMessages={[t("Validation.EnterPhoneNumber"), t("Validation.TenDigitPhoneNumber")]}
                          />
                        </div>
                        <br />
                        <Box sx={{ display: 'flex' }}>
                          <FormControl
                            variant='standard'
                            sx={{ m: '16px 0', minWidth: 347 }}
                          >
                            <InputLabel id='preferred-language-label'>
                              {t('Vendors.VendorDetails.PreferredLanguage')}
                            </InputLabel>
                            <Select
                              labelId='preferred-language-label'
                              id='preferred-language-select-standard'
                              value={preferLanguage || ''}
                              readOnly={readOnly}
                              onChange={this.onChangePreferredLanguage}
                              label={t('Vendors.VendorDetails.PreferredLanguage')}
                            >
                              {this.state &&
                                this.state.preferredLanguage.map(
                                  (item, index) => (
                                    <MenuItem
                                      key={index}
                                      value={item && item.id}
                                      selected
                                    >
                                      {item && item.label}
                                    </MenuItem>
                                  )
                                )}
                            </Select>
                          </FormControl>
                        </Box>
                      </div>
                      <div className={classes.rightChild}>
                      </div>
                    </div>
                  </DialogContent>
                  <div style={{ bottom: '0', width: '100%' }}>
                    <DialogActions sx={{ padding: '15px 12px 9px 4px' }}>
                      <Button
                        onClick={this.handleClose}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'View'
                          ? t('Vendors.CloseButton')
                          : t('Vendors.CancelButton')}
                      </Button>
                      {this.state.operation !== 'View' && (
                        <Button
                          type='submit'
                          disabled={this.state.isButtonDisabled}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {this.state.operation === 'Edit'
                            ? t('Vendors.UpdateVendorButton')
                            : t('Vendors.AddVendorButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </ValidatorForm>
              </div>
            </TabContainer>
          </SwipeableViews>
        </Dialog>
        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          deleteUsers={this.deleteUsers}
          editUser={this.editUser}
          confirmDelete={this.confirmDelete}
          uadd={this.state.useradd}
          udelete={this.state.userdelete}
          handleSearchChange={this.handleSearchChange}
          searchtxt={this.state.searchtext}
        />
        <div className={classes.tableWrapper}>
          <Menu
            id='long-menu'
            anchorEl={anchorEl}
            open={contextOpen}
            onClose={this.handleContextClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                // width: 200,
              },
            }}
          >
            {this.state.userview === true && (
              <MenuItem
                key='view'
                onClick={this.handleView}
                sx={{ height: '40px' }}
              >
                <ListItemText>{t('Vendors.ViewActions')}</ListItemText>
              </MenuItem>
            )}
            {this.state.useredit === true && (
              <MenuItem
                key='edit'
                onClick={this.handleEdit}
                sx={{ height: '40px' }}
              >
                <ListItemText>{t('Vendors.EditActions')}</ListItemText>
              </MenuItem>
            )}
            {this.state.userdelete === true && (
              <MenuItem
                disabled={this.state.isDisabled === true}
                key='delete'
                onClick={this.confirmDelete}
                sx={{ height: '40px' }}
              >
                <ListItemText>{t('Vendors.DeleteActions')}</ListItemText>
              </MenuItem>
            )}
            {this.state.keysgen === true && (
              <MenuItem
                disabled={this.state.isKeyGenerated}
                key='generateKeys'
                onClick={this.handleGenerate}
                sx={{ height: '40px' }}
              >
                <ListItemText>{t('Vendors.GenerateKeysActions')}</ListItemText>
              </MenuItem>
            )}
            {this.state.keysview === true && (
              <MenuItem
                disabled={!this.state.isKeyGenerated}
                key='viewKeys'
                onClick={this.handleKeysView}
                sx={{ height: '40px' }}
              >
                <ListItemText>{t('Vendors.ViewKeysActions')}</ListItemText>
              </MenuItem>
            )}
          </Menu>
          <Divider
            style={{
              marginTop: '10px',
              height: '5px',
              borderColor: 'rgba(0, 0, 0, 0.12)',
              borderStyle: 'solid',
              borderBottomWidth: '5px',
            }}
          />
          <Table className={classes.table} aria-labelledby='tableTitle'>
            <EnhancedTableHead
              numSelected={selected.length}
              order={FilterObj.sortOrder}
              orderBy={FilterObj.sortColumn}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data ? data.length : 0}
              sortId={this.state.sortId}
            />
            <TableBody>
              {!data ? (
                <TableRow>
                  <TableCell
                    colSpan={20}
                    sx={{ textAlign: 'center', padding: '10px 0px' }}
                  >
                    {this.state.isDataEmpty && t('Vendors.NoDataFound')}
                  </TableCell>
                </TableRow>
              ) : (
                data &&
                data.length > 0 &&
                data.map((n) => {
                  const isSelected = this.isSelected(n && n.vendor_unique_id)
                  const sx = {
                    color: 'rgba(0, 0, 0, 0.87)',
                    fontSize: '0.8125rem',
                    fontWeight: '400',
                  };
                  return (
                    <TableRow
                      hover
                      role='checkbox'
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={n && n.vendor_unique_id}
                      selected={isSelected}
                      sx={{ height: '50px' }}
                    >
                      <TableCell
                        padding='checkbox'
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                        sx={{ padding: '0 12px' }}
                      >
                        <Checkbox
                          checked={isSelected}
                          sx={{ '&.Mui-checked': { color: '#0ae' } }}
                        />
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        component='th'
                        scope='row'
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                      >
                        <Avatar alt='' src={n && n.logo_url && JSON.parse(n.logo_url).Location} />
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.name}
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.email}
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.phone}
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.cp_name}
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n && n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.cp_email}
                      </TableCell>
                      <TableCell
                        padding={'none'}
                        onClick={(event) => this.handleClick(event, n.vendor_unique_id)}
                        sx={{ ...sx }}
                      >
                        {n && n.cp_phone}
                      </TableCell>
                      <TableCell padding={'none'}>
                        <IconButton
                          aria-label='More'
                          aria-owns={contextOpen ? 'long-menu' : null}
                          aria-haspopup='true'
                          onClick={(event) => this.handleContextClick(event, n)}
                        >
                          <MoreVertIcon style={{ fontSize: 20 }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            sx={{ '.MuiInputBase-root': { fontSize: 'inherit' } }}
            rowsPerPageOptions={[5, 10, 25]}
            component='div'
            count={totalRecords || 0}
            rowsPerPage={FilterObj.pageSize}
            page={FilterObj.pageNo}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/vendor-list/index.js